export default {
  name: 'Aoption',
  props: {
    url: { type: String, default: () => '' },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    label: { type: String, default: () => '' },
    value: { type: String, default: () => '' },
  },
  data() {
    return {
      model: '',
    }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      this.model = this.value;
    },
  },
  render() {
    const { label, ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <el-select v-model={this.model} placeholder={`请选择${label}`} {...{ attrs }}>
        {data.length > 0 && data.map((a, b) => <el-option key={b} label={a.text || a.label || a.title || a.name} value={a.id || a.value || a.code} />)}
      </el-select>
    );
  }
}